import { Action } from 'redux';
import { PromoCodeFilters, PromoCodeModel } from '../../../api/pricing/pricing.types';
import { Page } from '../../../api/api.types';
import { UPDATE_BROKER_RATE_FILTERS } from '../../setup/types/brokerrate.types';

export const GET_PROMO_CODES_LIST = 'GET_PROMO_CODES_LIST';
export const GET_PROMO_CODE = 'GET_PROMO_CODE';
export const PUT_PROMO_CODE = 'PUT_PROMO_CODE';
export const POST_PROMO_CODE = 'POST_PROMO_CODE';
export const DELETE_PROMO_CODE = 'DELETE_PROMO_CODE';
export const UPDATE_PROMO_CODE_FILTERS = 'UPDATE_PROMO_CODE_FILTERS';

export interface PromoCodesState {
  promoCodes: PromoCodeModel[] | [];
  selectedPromoCode: PromoCodeModel | null;
  postSuccess: boolean | null;
  lastFetch: number | null;
  totalElements: number;
  totalPages: number;
  filters: PromoCodeFilters | null;
}

export interface GetPromoCodesListAction extends Action {
  type: typeof GET_PROMO_CODES_LIST;
  payload: {
    page: Page<PromoCodeModel>;
  };
}

export interface GetPromoCodeAction extends Action {
  type: typeof GET_PROMO_CODE;
  payload: {
    selectedPromoCode: PromoCodeModel | null;
  };
}

export interface PutPromoCodeAction extends Action {
  type: typeof PUT_PROMO_CODE;
  payload: {
    selectedPromoCode: PromoCodeModel;
  };
}

export interface PostPromoCodeAction extends Action {
  type: typeof POST_PROMO_CODE;
  payload: {
    newPromoCode: PromoCodeModel;
    success: boolean;
  };
}

export interface DeletePromoCodeAction extends Action {
  type: typeof DELETE_PROMO_CODE;
  payload: {
    success: boolean;
  };
}

export interface UpdatePromoCodeFiltersAction extends Action {
  type: typeof UPDATE_PROMO_CODE_FILTERS;
  payload: {
    filters: PromoCodeFilters;
  };
}

export type PromoCodeActionTypes = GetPromoCodesListAction | GetPromoCodeAction | PutPromoCodeAction | PostPromoCodeAction | DeletePromoCodeAction | UpdatePromoCodeFiltersAction;
